import React from "react";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import Header from '../../components/headers/MainHeader';
import Footer from "../../components/footers/MainFooterWithLinks";
import { useTranslation } from "react-i18next";

import DataIcon from "./Forbiddencookies/data.jpg";
import GunIcon from "./Forbiddencookies/gun.jpg";
import ToxicIcon from "./Forbiddencookies/toxic.jpg";
import SprayIcon from "./Forbiddencookies/spray.jpg";
import DrugIcon from "./Forbiddencookies/rast.jpg";
import HeartIcon from "./Forbiddencookies/organ.jpg";
import SobelIcon from "./Forbiddencookies/sobol.jpg";
import DiamondIcon from "./Forbiddencookies/diamond.jpg";
import MineralIcon from "./Forbiddencookies/miniral.jpg";
import MapIcon from "./Forbiddencookies/map.jpg";
import TreeIcon from "./Forbiddencookies/tree.jpg";
import FishIcon from "./Forbiddencookies/fish.jpg";
import PoisonIcon from "./Forbiddencookies/poison.jpg";
import MoneyIcon from "./Forbiddencookies/money.jpg";
import CrossIcon from "./Forbiddencookies/cross.jpg";
import BunnyIcon from "./Forbiddencookies/bunny.jpg";
import DogIcon from "./Forbiddencookies/dog.jpg";
import SeedIcon from "./Forbiddencookies/seed.jpg";
import GearIcon from "./Forbiddencookies/gear.jpg";
import CandleIcon from "./Forbiddencookies/candle.jpg";
import FireIcon from "./Forbiddencookies/fire.jpg";
import CamIcon from "./Forbiddencookies/cam.jpg";
import PictureIcon from "./Forbiddencookies/picture.jpg";
import AccIcon from "./Forbiddencookies/acc.jpg";
import MedicIcon from "./Forbiddencookies/medic.jpg";
import FruitIcon from "./Forbiddencookies/fruit.jpg";
import SmokeIcon from "./Forbiddencookies/smoke.jpg";
import TimerIcon from "./Forbiddencookies/timer.jpg";
import WtfIcon from "./Forbiddencookies/wtf.jpg";
import AnyIcon from "./Forbiddencookies/any.jpg";
import DesignIllustration from "../../images/img/Запрещенные товары. КЗ.png";

const Container = tw.div`relative bg-white min-h-screen`;
const Content = tw.div`max-w-screen-xl mx-auto py-12 lg:py-16`;
const CardWrapper = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8`;
const Card = styled.div`
    ${tw`flex flex-col items-center p-4 bg-white shadow-lg rounded-lg text-center text-lg font-bold`}
    img { ${tw`w-16 h-16 mb-4`} }
    p { ${tw`mt-2`} }
`;

function ProhibitedItems() {
    const { t } = useTranslation();

    const prohibitedItems = [
        { icon: DataIcon, description: t("prohibited.items.1") },
        { icon: GunIcon, description: t("prohibited.items.2") },
        { icon: ToxicIcon, description: t("prohibited.items.3") },
        { icon: SprayIcon, description: t("prohibited.items.4") },
        { icon: PoisonIcon, description: t("prohibited.items.5") },
        { icon: HeartIcon, description: t("prohibited.items.6") },
        { icon: SobelIcon, description: t("prohibited.items.7") },
        { icon: CandleIcon, description: t("prohibited.items.8") },
        { icon: MineralIcon, description: t("prohibited.items.9") },
        { icon: MapIcon, description: t("prohibited.items.10") },
        { icon: TreeIcon, description: t("prohibited.items.11") },
        { icon: FishIcon, description: t("prohibited.items.12") },
        { icon: DrugIcon, description: t("prohibited.items.13") },
        { icon: MoneyIcon, description: t("prohibited.items.14") },
        { icon: CrossIcon, description: t("prohibited.items.15") },
        { icon: BunnyIcon, description: t("prohibited.items.16") },
        { icon: DogIcon, description: t("prohibited.items.17") },
        { icon: SeedIcon, description: t("prohibited.items.18") },
        { icon: DrugIcon, description: t("prohibited.items.19") },
        { icon: DiamondIcon, description: t("prohibited.items.20") },
        { icon: FireIcon, description: t("prohibited.items.21") },
        { icon: PictureIcon, description: t("prohibited.items.22") },
        { icon: CamIcon, description: t("prohibited.items.23") },
        { icon: DiamondIcon, description: t("prohibited.items.24") },
        { icon: GearIcon, description: t("prohibited.items.25") },
        { icon: FishIcon, description: t("prohibited.items.26") },
        { icon: AccIcon, description: t("prohibited.items.27") },
        { icon: MedicIcon, description: t("prohibited.items.28") },
        { icon: FruitIcon, description: t("prohibited.items.29") },
        { icon: SmokeIcon, description: t("prohibited.items.30") },
        { icon: TimerIcon, description: t("prohibited.items.31") },
        { icon: WtfIcon, description: t("prohibited.items.32") },
        { icon: AnyIcon, description: t("prohibited.items.33") }
    ];

    return (
        <AnimationRevealPage>
            <Header
                heading={t("prohibited.title")}
                paragraph={t("prohibited.paragraph")}
                imageSrc={DesignIllustration}
                roundedHeaderButton={false}
            />
            <Container>
                <Content>
                    <CardWrapper>
                        {prohibitedItems.map((item, index) => (
                            <Card key={index}>
                                <img src={item.icon} alt="Icon" />
                                <p>{item.description}</p>
                            </Card>
                        ))}
                    </CardWrapper>
                </Content>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
}

export default ProhibitedItems;
